// contains all section and snippet scripts
// Load this file on product templates.

// Script For Dyno Chart Selector

document.addEventListener('DOMContentLoaded', function() {
  const dynoSelector = document.getElementById('dyno-selector');
  const images = document.querySelectorAll('.dyno-graph-image');
  
  let isZoomed = false;
  
  // Show the initially selected image
  showImage(dynoSelector.value);

  // Event listener for dropdown change
  dynoSelector.addEventListener('change', function() {
    showImage(this.value);
  });

  // Function to show the selected image and reset zoom
  function showImage(selectedId) {
    images.forEach(image => {
      if (image.id === 'dyno-image-' + selectedId) {
        image.style.display = 'block'; // Show the selected image
      } else {
        image.style.display = 'none'; // Hide all others
      }
    });
  }
});